import React, { useState, useEffect, useCallback } from 'react';
import { List, Spin, Row, Col } from 'antd';

import BaseAlert from 'components/wrappers/BaseAlert';
import BasePageCard from 'components/wrappers/BasePageCard';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { getTotalNumbers } from 'redux/reducers/dashboardSlice';
import { GetTotalNumbersResponse } from 'api/adminApiClient';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from './TotalNumbers.module.less';

export default function TotalNumbers() {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [totalNumbers, setTotalNumbers] = useState<GetTotalNumbersResponse>();

  const loadTotalNumbers = useCallback(async () => {
    setIsLoading(true);
    const result = await dispatch(getTotalNumbers());
    setIsLoading(false);

    if (getTotalNumbers.fulfilled.match(result)) {
      setTotalNumbers(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  }, [dispatch]);

  useEffect(() => {
    loadTotalNumbers();
  }, [loadTotalNumbers]);

  if (isLoading) return <Spin />;

  if (!totalNumbers) return null;

  const listData = [
    {
      label: 'Members',
      value: totalNumbers.recruiterMembers,
    },
    {
      label: 'Corporate TA Members',
      value: totalNumbers.corporateMembers,
    },
    {
      label: 'Approved Total Customers',
      value: totalNumbers.customers,
    },
    {
      label: 'Approved Total Assignments',
      value: totalNumbers.assignments,
    },
  ];

  return (
    <BasePageCard
      className="full-header stretch-card"
      title="Total Numbers"
      icons={<span className="icon icon-number-list" />}
    >
      <List
        dataSource={listData}
        renderItem={({ label, value }) => (
          <List.Item>
            <Row gutter={[2, 2]}>
              <Col xs={24} lg={14}>
                <b>{label}</b>
              </Col>

              <Col xs={24} lg={10}>
                <div className={styles.value}>{value}</div>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </BasePageCard>
  );
}
